import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class B2BCoresValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let paleta = model;

        if (!paleta.descricao) {
            refs.nomeInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'necessario-cor', true))
        }
        
        return validated;
    }

}